import React, { useEffect, useState } from 'react'
import logo from "../../Assets/images/main-logo.svg"
import userimage from "../../Assets/images/user.png"
import ULFLAG from '../../Assets/images/ukFlag.png'
import SAFLAG from '../../Assets/images/spanishFlag.png'
import useMakeRequest from '../../utils/ApiHelper'
import { ApiConstants } from '../../constants/ApiConstants'
import { useDispatch, useSelector } from 'react-redux'
import { ProfileAction } from '../../redux/Action/Authaction'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import { ApiTypes, StorageConstant, VALIDATION_MESSAGE } from '../../constants/Constants'
import { Modal } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup';
import { ErrorMessage } from '@hookform/error-message';
import ChangePasswordValidation from '../../Validation/ChangePasswordValidation'
import DeleteAccount from '../../Modal/DeleteAccount'
import { deleteFromStorage, encodeID, getFromStorage, saveToStorage } from '../../utils/Helper'
import { Config } from '../../config/Config'
import { LanguageConstants } from '../../constants/LanguageConstants'
import RequestQuoteModal from '../../Modal/RequestQuoteModal'
import ContactusModal from '../../Modal/ContactusModal'
import FrontLoader from './FrontLoader'
import sentImg from "../../Assets/images/send-img.svg"
import orderCart from '../../Assets/images/shopping-cart.png'
import { useLocation } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

interface FormInputs {
  old_password: string;
  password: string;
  confirm_password: string;

};

function Header() {
  const location = useLocation()
  const { state } = useLocation();
  const navigate = useNavigate()
  const [show, setShow] = useState(false)
  const [quoteshow, setQuoteshow] = useState(false)
  const [changepassword, setChangePassword] = useState(false)
  const [contacShow, setContactShow] = useState(false)
  const [data, setData] = useState<any>({})
  const dispatch = useDispatch()
  const profiledata = useSelector((state: any) => state?.ProfileState)
  const Logout = useMakeRequest()
  const currencyGet = useMakeRequest()
  const [old, setOld] = useState(false)
  const [newp, setNewp] = useState(false)
  const [cpassword, setCpassword] = useState(false)
  const Changepassword = useMakeRequest()
  const [deleteShow, setDeleteShow] = useState(false)
  const Translate: any = getFromStorage({ key: StorageConstant?.Translate });
  const deleteAccount = useMakeRequest()
  const updateLang = useMakeRequest()
  const [lang, setLang] = useState('')

  useEffect(() => {
    const token = getFromStorage({ key: StorageConstant?.ACCESS_TOKEN })
    currencyGet.makeRequest({ url: ApiConstants?.currencyget, type: ApiTypes.GET, toastStatus: false })
    if (token) {
      // @ts-ignore
      dispatch(ProfileAction())
    }
  }, [])

  const { register, watch, setValue, formState: { errors }, handleSubmit } = useForm<FormInputs>({
    mode: 'onChange',
    resolver: yupResolver(ChangePasswordValidation),
  });
  const handleLogout = async () => {
    Swal.fire({
      title: LanguageConstants?.ARE_YOU_SURE,
      text: LanguageConstants?.YOU_WANT_TO_LOGUT,
      icon: 'warning',
      // showCancelButton: true,
      confirmButtonColor: '#31CE36',
      cancelButtonColor: '#d33',
      showDenyButton: true,
      denyButtonText: 'No',
      confirmButtonText: LanguageConstants?.YES,
    }).then(async (result: any) => {
      if (result.isConfirmed) {
        Logout.makeRequest({ url: ApiConstants?.LogOut, toastStatus: true })
        deleteFromStorage({ key: "access_token", type: 'local' })
        deleteFromStorage({ key: "currencyValue", type: 'local' })
        deleteFromStorage({ key: "user_data", type: 'local' })
        window.location.href = `${Config?.BASE_URL}/login`;
      }
    });
  }

  const onSubmit = (payload: FormInputs) => {
    Changepassword.makeRequest({ payload, url: ApiConstants?.ChangePassword, toastStatus: true })
  }
  useEffect(() => {
    if (Changepassword?.status) {
      setChangePassword(false)
      setValue('confirm_password', '')
      setValue('old_password', '')
      setValue('password', '')
    }
  }, [Changepassword?.status])
  const handleClose = () => {
    setChangePassword(false)
    setValue('confirm_password', '')
    setValue('old_password', '')
    setValue('password', '')
    setOld(false)
    setNewp(false)
    setCpassword(false)
  }

  useEffect(() => {
    if (currencyGet?.status) {
      localStorage.setItem('currencyValue', encodeID(currencyGet?.data?.data))
    }
  }, [currencyGet?.status])

  const handleDeleteClose = () => {
    setDeleteShow(false)
  }

  const handelLanguage = (lang: any) => {
    if(profiledata?.data?.data){
      const payload = {
        lang_id : lang == "spa" ? '2' :'1'
      }
    updateLang.makeRequest({ payload, url: ApiConstants?.LangUpdate, toastStatus: false })
    saveToStorage({ key: "Translate", value: lang })
    }else{
    saveToStorage({ key: "Translate", value: lang })
    window.location.reload()
    }
  }


  const navigateToQuote = () => {
    setQuoteshow(true)
  }

  const navigateToQuoteClose = () => {
    setQuoteshow(false)
  }

  const handelContactUsClose = () => {
    setContactShow(false)
  }


  const handelDelete = () => {
    if (profiledata?.data?.data?.social_id) {
      Swal.fire({
        title: LanguageConstants?.ARE_YOU_SURE,
        text: LanguageConstants?.YOU_WANT_TO_DELETE,
        icon: 'warning',
        // showCancelButton: true,
        confirmButtonColor: '#31CE36',
        cancelButtonColor: '#d33',
        showDenyButton: true,
        denyButtonText: 'No',
        confirmButtonText: LanguageConstants?.YES,
      }).then(async (result: any) => {
        if (result.isConfirmed) {
          const payload = {
            social_id: profiledata?.data?.data?.social_id
          }
          deleteAccount.makeRequest({ payload, url: ApiConstants?.DeleteAccount, toastStatus: true })
        }
      });
    } else {
      setDeleteShow(true)
    }
  }

  useEffect(() => {
    if (deleteAccount?.status) {
      deleteFromStorage({ key: "access_token", type: 'local' })
      localStorage.clear()
      window.location.href = `${Config?.BASE_URL}/login`;
    }
    if(updateLang?.status){
    window.location.reload()
    }
  }, [deleteAccount?.status , updateLang?.status])

  useEffect(()=>{
   if(profiledata?.data?.data?.is_category_select == "0"){
    navigate('/category')
   }
  },[profiledata , location.pathname])

  useEffect(()=>{
  if(state?.data?.modelShow == true){
    setQuoteshow(true)
  }
  },[state?.data?.modelShow])
  return (
    <>
      {deleteAccount.loading || updateLang?.loading ? <FrontLoader /> : null}
      <header>
        <nav className="navbar navbar-expand-lg fixed-top">
          <div className="container">
            <Link className="navbar-brand" to={`/`}><img src={logo} /></Link>
            {profiledata?.data?.data ?
              <a className="com-btn com-btn-outline head-login-btn d-lg-none ms-auto me-2 me-sm-3" onClick={() => handleLogout()} >Logout</a>
              :
              <Link to='/login' className="com-btn com-btn-outline head-login-btn d-lg-none ms-auto me-2 me-sm-3" >Login</Link>
            }
            <button className="navbar-toggler ms-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon" />
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ms-auto pt-3 pt-lg-0">
               
              </ul>
              <div className="nav-right-side pb-2 pb-lg-0 pt-4 pt-lg-0">
                { profiledata?.data?.data  && location.pathname != '/category' ?
                    <div className='head-btn-wrap'>
                        <Link to={'/my-quotation'} className="head-btn" style={{ cursor: 'pointer' }} >
                            {LanguageConstants?.MYOUESTION}
                        </Link>
                        <Link to={'/order'} className="head-btn" style={{ cursor: 'pointer' }} >
                            {LanguageConstants?.MYORDER}
                        </Link>
                    </div>
                : null}

                {!profiledata?.data?.data ?
                  <Link to='/login' className="com-btn com-btn-outline head-login-btn d-lg-flex d-none">{LanguageConstants?.LOGIN}</Link>
                  : null}
                {profiledata?.data?.data && location?.pathname == '/' ?
                  <a onClick={() => navigateToQuote()} className="animated-btn d-block" style={{ cursor: 'pointer' }} >
                    <div className="fillOverlay"></div>
                    <div className="quoteWrapper">
                      <span className="buttonText">{LanguageConstants?.REQUESTQUOTES}</span>
                    </div>
                    <div className="planeWrapper">
                      <img src={sentImg} alt="Plane" className="planeImage" />
                    </div>
                    <div className="letsGoWrapper">
                      <span className="buttonText">{LanguageConstants?.LETS_GO}</span>
                    </div>
                  </a>
                  : 
                   null
                  }
                  {location?.pathname == '/my-quotation' || location?.pathname == '/order' ?
                  <a onClick={() => navigateToQuote()} className="head-btn" style={{ cursor: 'pointer' }} >
                    {LanguageConstants?.REQUESTQUOTES}
                  </a>
                  :null}
                {profiledata?.data?.data && location?.pathname !='/category' ?
                  <div className="nav-item header-dropdown" onClick={() => setShow(!show)}>
                    <div className="dropdown-btn">
                      <div className="drop-img"><img src={profiledata?.data?.data?.profile_pic ? profiledata?.data?.data?.profile_pic : userimage} /></div>
                      <div>
                        {/* <span className="drop-id">{profiledata?.data?.data?.email}</span> */}
                      </div>
                      <i className="arw icon-chev-btm text-dark" />
                        <ul className="drop-list">
                          <li>
                            <Link to="/my-quotation" className="txt" ><span>{LanguageConstants?.MYOUESTION}</span></Link>
                          </li>
                          <li>
                            <Link to='/order' className="txt" ><span>{LanguageConstants?.MYORDER}</span></Link>
                          </li>
                          <li>
                            <Link to='/address' className="txt" ><span>{LanguageConstants?.MYADDRESS}</span></Link>
                          </li>

                          <li>
                            <div className="has-dropdown txt"><span className="has-dropdown-txt">{LanguageConstants?.SETTING} <i className="arw-next icon-chev-right"></i></span>
                              <ul className="drop-list">
                                <li>
                                  <Link to='/profile' className="txt" ><span>{LanguageConstants?.VIEWPROFILE}</span></Link>
                                </li>
                                 <li>
                                  <Link to='/update-category' className="txt" ><span>{LanguageConstants?.CATEGORY_SELECTION} </span></Link>
                                </li>
                                {!profiledata?.data?.data?.social_id ?
                                  <li>
                                    <div className="txt" onClick={() => setChangePassword(true)}><span>{LanguageConstants?.CHANGEPASSWORD}</span></div>
                                  </li>
                                  : null}
                                <li>
                                  <div className="txt" onClick={() => handelDelete()}><span>{LanguageConstants?.DELETEACCOUNT} </span></div>
                                </li>
                                <li>
                                  <div className="txt" onClick={() => handleLogout()} ><span>{LanguageConstants?.LOGOUT}</span></div>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      {/* {show ?
                        : null} */}
                    </div>
                    <span className="drop-name"
                    style={{display: "block",fontSize: "12px",fontWeight: 500,color: "var(--black-2)"}}
                    >{profiledata?.data?.data?.name?.split(" ")?.map((w:any, i:any) => (i == 1 ? w[0] + "." : w))?.join(" ")}</span>
                  </div>
                  : null}

                {!profiledata?.data?.data ?
                  <Link to='/login' className="head-notify"><i className="icon-bell" />
                  </Link>
                  :
                  <>
                  {location?.pathname !='/category' ? 
                    <Link to='/notification' className="head-notify"><i className="icon-bell" />
                      {profiledata?.data?.data?.notification_detail ?
                        <span className="indicator" />
                        : null}
                    </Link>
                    :null}
                  </>
                }
                <div className="lang-dropdown">
                  {/* <i className="icon-language" /> */}
                  {getFromStorage({ key: "Translate" }) == "spa" ?
                    <i style={{ width: '30px', height: '30px', paddingLeft: '3px' }} > <img src={SAFLAG} alt='flag' /> </i>
                    :
                    <i style={{ width: '30px', height: '30px', paddingLeft: '3px' }} > <img src={ULFLAG} alt='flag' /> </i>
                  }

                  <div className="dropdown">
                    <button className="dropdown-toggle" type="button" id="langDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                      {Translate == "spa" ? LanguageConstants?.SPA : "ENG"}
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="langDropdown">
                      <li onClick={() => handelLanguage('en')} style={{ cursor: 'pointer' }} ><a className="dropdown-item" >{LanguageConstants?.ENGLISH}</a></li>
                      <li onClick={() => handelLanguage('spa')} style={{ cursor: 'pointer' }} ><a className="dropdown-item">{LanguageConstants?.SPANISH}</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* <!-- forgot password modal  --> */}
      <Modal show={changepassword}>
        <div className="modal fade auth-modal text-center show" id="forgotPassModal" aria-labelledby="forgotPassModalLabel" aria-hidden="false" style={{ display: 'block' }} >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="forgotPassModalLabel">{LanguageConstants?.CHANGEPASSWORD}</h5>
                <button type="button" className="btn-close" onClick={() => handleClose()} data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square"></i></button>
              </div>
              <div className="modal-body pb-0">
                <div className='mb-4'>
                  <div className="com-floating">
                    <i className="f-icon icon-lock"></i>
                    <label className="f-label">{LanguageConstants?.OLD_PASSOWRD} <span className="must-star">*</span></label>
                    <input className="f-input" type={old ? "text" : 'password'} placeholder={LanguageConstants?.OLD_PASSOWRD}  {...register('old_password')} />
                    <i className={old ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={() => setOld(!old)}></i>

                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="old_password"
                    render={({ message }) => <p className='text-error text-start'>{message}</p>}
                  />
                </div>
                <div className='mb-4'>
                  <div className="com-floating">
                    <i className="f-icon icon-lock"></i>
                    <label className="f-label">{LanguageConstants?.NEW_PASSWORD} <span className="must-star">*</span></label>
                    <input className="f-input" type={newp ? "text" : 'password'} placeholder={LanguageConstants?.NEW_PASSWORD} {...register('password')} />
                    <i className={newp ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={() => setNewp(!newp)}></i>
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="password"
                    render={({ message }) => <p className='text-error text-start'>{message}</p>}
                  />
                </div>
                <div className='mb-4'>

                  <div className="com-floating">
                    <i className="f-icon icon-lock"></i>
                    <label className="f-label">{LanguageConstants?.CONFIRMA_PASSWORD} <span className="must-star">*</span></label>
                    <input className="f-input" type={cpassword ? "text" : 'password'} placeholder={LanguageConstants?.CONFIRMA_PASSWORD} {...register('confirm_password')} />
                    <i className={cpassword ? "f-pass icon-eye-open" : "f-pass icon-eye-slash-fill"} onClick={() => setCpassword(!cpassword)}></i>
                  </div>
                  <ErrorMessage
                    errors={errors}
                    name="confirm_password"
                    render={({ message }) => <p className='text-error text-start'>{message}</p>}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" disabled={Changepassword?.loading ? true : false} className="round-btn m-0" data-bs-dismiss="modal" onClick={handleSubmit(onSubmit)}   >{LanguageConstants?.SUBMIT}</button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* <!-- forgot password modal  --> */}

      {/* <!-- Delete account  --> */}
      <Modal show={deleteShow} >
        <DeleteAccount handleClso={handleDeleteClose} />
      </Modal>
      {/* <!-- Delete account  --> */}

      {/* Request Quote modal */}
      <Modal show={quoteshow} >
        <RequestQuoteModal handelClso={navigateToQuoteClose} />
      </Modal>
      {/* Request Quote modal */}

      {/* Contact us modal */}
      <Modal show={contacShow} >
        <ContactusModal handelClso={handelContactUsClose} />
      </Modal>
      {/* Contact us modal */}

    </>
  )
}

export default Header
